
$(document).ready(function(){
  $(document).on('click','.closeann',function(){
    $('.annoubar').fadeOut();
  });
  $('.annoslider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000
  });

  $(document).on("click",'.catalog__grid-block',function(){
    $('.catalog__grid-block').removeClass('active');
    $(this).addClass('active');
    var numberrow= $(this).attr('data-row');
    $('.productscollection').removeClass('grid--2-col-desktop  grid--3-col-desktop grid--4-col-desktop')
    $('.productscollection').addClass('grid--'+numberrow+'-col-desktop');
  });

  $(document).on('click','.acc_list .acc_title',function() {
    var current_status = $(this).parent().find(".acc_desc").css('display');
    $('.acc_title').removeClass('active');
    $('.acc_list .acc_desc').slideUp();
    if(current_status == 'none') {
      $(this).addClass('active');
      $(this).parent().find(".acc_desc").slideDown();
    }
  });
  $('.imageslider').slick({
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: '60px',
    slidesToScroll: 1,
    arrows: false
  });
  $(document).on('click','.playimage',function() {
    var video = $(this).closest('.video_block').find('.video_slide')[0];
    if (video.paused) {
      video.play();
      $(this).find('#icon_play').hide();
    } else {
      video.pause();
      $(this).find('#icon_play').show();
    }
  });

  $('.image-text-slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    arrows: true,
    dots: false,
    pauseOnHover: false,
  });

  $(document).on('click','.quickview-button',function() {
    $(this).closest('.quickview-section').find('.quickview-container').show();
    $(body).addClass('fixed');
  });
  $(document).on('click','.closequick',function() {
    $('.quickview-container').hide();
    $(body).removeClass('fixed');
  });

  $('.customer-logos').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 520,
      settings: {
        slidesToShow: 3
      }
    }]
  });

  const logoslider = $(".customer-logos , .image-text-slide");

  logoslider.on('wheel', (function(e) {

    var slideCount = $(this)[0].slick["slideCount"];
    var currentIndex = $(this).slick("slickCurrentSlide");
    var totalSildeToShow =  $(this)[0].slick.options["slidesToShow"];

    if (e.originalEvent.deltaY < 0) {

      e.preventDefault();
      $(this).slick('slickPrev');

    } else {
      if (slideCount - totalSildeToShow === currentIndex)
        return;
      //e.preventDefault();
      $(this).slick('slickNext')
    }
  }));
  $(document).on('click','.contact_fieldtype label',function(){
    $('.contact_fieldtype label').removeClass('active');
    $(this).addClass('active');
    $('#ContactForm-type').val($(this).text());
  });
  $(document).on("click",".text--faq",function(){
    var dataid = $(this).attr("data-linked-id");
    console.log(dataid)
    $("html,body").animate({scrollTop:$(dataid).offset().top},"slow")
  });

  var attr = $('.product-option').attr('data-option');
  if (typeof attr !== typeof undefined && attr !== false) {
    console.log('gereg');
  }

});



/*################ Collection-boxes  ###### */


